import { Box, Button, Flex, Icon, Text, Checkbox, Wrap, WrapItem } from '@chakra-ui/react'
import { FiSearch } from 'react-icons/fi'
import { useFormContext } from 'react-hook-form'
import { statusArray } from '../utils/statusConfig'
import { CustomInputOmni } from '../../../../../components/CustomInputOmni'
import { CustomSelectOmni } from '../../../../../components/CustomSelectOmni'
import { useEffect } from 'react'
export function FilterForm({ onSubmit, onClear, isSubmitting, tiposGravacaoDisponiveis = [] }) {
  const { register, handleSubmit, setValue, getValues } = useFormContext()

  useEffect(() => {
    if (!statusArray.includes(getValues('status'))) {
      setValue('status', 'aguardando')
    }
  }, [getValues, setValue])
  return (
    <Box as="form" onSubmit={handleSubmit(onSubmit)} mb={4} p={4} borderRadius="8px" bg="#F9F9F9">
      {/* Linha superior de filtros */}
      <Flex flexWrap={{ base: 'wrap', md: 'nowrap' }} gap={4} mb={4} alignItems="flex-end">
        {/* <Box>
          <CustomInputOmni label="Número" placeholder="Número pedido" {...register('numeroPedido')} maxW="210px" />
        </Box> */}

        {/* Campo De: */}
        <Box>
          <CustomInputOmni label="De" placeholder="dd/mm/aaaa" type="date" {...register('dataInicio')} maxW="210px" />
        </Box>

        {/* Campo Até: */}
        <Box>
          <CustomInputOmni label="Até" placeholder="dd/mm/aaaa" type="date" {...register('dataFim')} maxW="210px" />
        </Box>

        {/* Campo Status Atual */}
        <Box>
          <CustomSelectOmni label="Passo atual" placeholder="Passo atual" {...register('passoAtual')} maxW="210px">
            {statusArray.map((status) => (
              <option key={status} value={status}>
                {status}
              </option>
            ))}
          </CustomSelectOmni>
        </Box>

        {/* Campo Próxima Etapa */}
        <Box>
          <CustomSelectOmni label="Próximo passo" placeholder="Próximo passo" {...register('proximoPasso')} maxW="210px">
            {statusArray.map((status) => (
              <option key={status} value={status}>
                {status}
              </option>
            ))}
          </CustomSelectOmni>
        </Box>

        {/* Campo ID do Pedido */}
        <Box>
          <CustomInputOmni label="ID do Pedido" pl="100px" {...register('idPedido')} maxW="210px" />
        </Box>

        <Box>
          <CustomSelectOmni label="Status" placeholder="Selecione o status" {...register('status')} maxW="210px">
            <option value="todos">Todos</option>
            <option value="negado">Negado</option>
            <option value="aprovado">Aprovado</option>
            <option value="aguardando">Aguardando</option>
          </CustomSelectOmni>
        </Box>

        {/* Botão Buscar */}
        <Button
          type="submit"
          leftIcon={<Icon as={FiSearch} />}
          colorScheme="blue"
          bg="#378BBF"
          fontSize="12px"
          px={6}
          py={2}
          h="40px"
          borderRadius="8px"
          isLoading={isSubmitting}
          loadingText="Buscando..."
        >
          Buscar
        </Button>
      </Flex>

      {/* Checkboxes de tipos de gravação - Agora dinâmicos com base nos dados */}
      {tiposGravacaoDisponiveis.length > 0 && (
        <Wrap spacing={6} mt={4} mb={2} justify="center">
          {tiposGravacaoDisponiveis.map((tipo) => (
            <WrapItem key={tipo}>
              <Checkbox colorScheme="blue" size="md" {...register(`tiposGravacao.${tipo}`)}>
                <Text fontSize="12px" color="#313E44">
                  {tipo}
                </Text>
              </Checkbox>
            </WrapItem>
          ))}
        </Wrap>
      )}
    </Box>
  )
}
